import React from 'react';

function TheatreSuctionTrolley() {
  return (
    <>
      <style>{`
        .trolley-container {
          padding: 2rem;
          background-color: #f9f9f9;
          font-family: 'Segoe UI', sans-serif;
        }

        .trolley-section {
          max-width: 900px;
          margin: 0 auto;
          background-color: #fff;
          padding: 2rem;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .trolley-section h1 {
          font-size: 2.4rem;
          text-align: center;
          margin-bottom: 1.5rem;
          color: #2c3e50;
        }

        .trolley-section img {
          display: block;
          margin: 0 auto 1.5rem;
          max-width: 100%;
          height: auto;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .trolley-section p {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #444;
          text-align: justify;
        }

        @media (max-width: 768px) {
          .trolley-section h1 {
            font-size: 2rem;
          }

          .trolley-section p {
            font-size: 1rem;
          }

          .trolley-container {
            padding: 1rem;
          }
        }
      `}</style>

      <main className="trolley-container">
        <section className="trolley-section">
          <h1>Theatre Suction Trolley</h1>
          <img src="tst.png" alt="Theatre Suction Trolley" />
          <p>
            We are one of the trusted names in manufacturing a range of Theatre Suction Trolleys that
            cater to the diversified requirements of the medical industry. These trolleys are used in
            operation theatres, accident zones, as well as for emergency purposes. We offer this
            product range at the most competitive prices to our clients.
          </p>
        </section>
      </main>
    </>
  );
}

export default TheatreSuctionTrolley;
